import React, { useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

// بيانات المقالات
const blogPosts = {
  'how-formly-saves-5-hours': {
    id: 'how-formly-saves-5-hours',
    title: 'كيف يوفر Formly AI للمستخدمين أكثر من 5 ساعات أسبوعياً في المهام الإدارية',
    category: 'مميز',
    author: 'أحمد ريفيرا',
    authorImage: 'https://lh3.googleusercontent.com/aida-public/AB6AXuATRM3UNVWbVqaidOFF0uSpWP1NocSPl36s_6ZYswS66ATVGd0QZ0sJuQ073KtjYjtYMUfO-NgeCAZIw8mOFpcpK53o9uEyDhBUHi7veJ_JscsmQGracQ_vMmt0Owfz4IjtY7OB-VZMoaa8v7No_4uaX5dSomN2g8Kuh10NUvnPveURtV49HWFk2A7HFN4gqebT2nuz_f0YL1yholcDqDQDfrpFlBBi-jX5xuOxQosXKxFp1H7PV8jo7ZeYgRT91NRZWiyQgtzl064',
    date: '14 ديسمبر 2023',
    readTime: '8 دقائق قراءة',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDedyeJCTcJmmA9-QxcpSYQXqfxDhFf7qlNa4MGxWnrYRhLxeFJsZ_Mr4LSqDgBDIVbO1wauTZfVC3Dy8Sap3FSlLw-0ZKDWGnqMgE1hHY9_9QbpB4hMMfBjCA3fRxObvdVbYb0cM4Jugs-d1bGfOpwkdGn8OXrFZ5NwRl6_GbK8iz4kS3PRT43OEoj1Ne64o4uIrgk5-gmaCu6hyW1L8cP-zPzXWyDHdE81yx9vg48WE8_L2DFpR1UlxiHItMigLV1ON8y6TYndko',
    excerpt: 'اكتشف كيف أن ملء النماذج الذكي يحدث ثورة في طريقة تعامل المحترفين مع إدخال البيانات المتكرر وسير العمل الإداري المعقد باستخدام الذكاء الاصطناعي الحديث.',
    content: `
      <p class="text-base leading-relaxed mb-6">في عالم اليوم السريع، حيث الوقت هو أثمن الموارد، أصبحت المهام الإدارية المتكررة عبئاً ثقيلاً على المحترفين. من ملء النماذج الطويلة إلى إدخال البيانات المتكررة، هذه المهام تستنزف ساعات ثمينة يمكن استغلالها في أعمال أكثر إنتاجية.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">المشكلة الحقيقية</h2>
      <p class="text-base leading-relaxed mb-6">وفقاً لدراسات حديثة، يقضي الموظف العادي ما يقرب من 5-7 ساعات أسبوعياً في ملء النماذج وإدخال البيانات. هذا الوقت الضائع لا يؤثر فقط على الإنتاجية، بل يزيد أيضاً من احتمالية الأخطاء البشرية.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">الحل: Formly AI</h2>
      <p class="text-base leading-relaxed mb-6">Formly AI يغير قواعد اللعبة من خلال استخدام الذكاء الاصطناعي المتقدم لملء النماذج تلقائياً. باستخدام تقنيات التعلم الآلي، يمكن للإضافة التعرف على الحقول المختلفة وملئها بدقة عالية.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">كيف يعمل؟</h2>
      <p class="text-base leading-relaxed mb-6">عند تثبيت Formly AI، تقوم الإضافة بإنشاء ملف شخصي آمن يحتوي على معلوماتك الأساسية. عند زيارة أي نموذج، تتعرف الإضافة تلقائياً على الحقول وتقترح ملء البيانات المناسبة.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">النتائج</h2>
      <p class="text-base leading-relaxed mb-6">المستخدمون الذين يستخدمون Formly AI يوفرون في المتوسط أكثر من 5 ساعات أسبوعياً. هذا الوقت الإضافي يمكن استغلاله في:</p>
      <ul class="list-disc list-inside space-y-2 mb-6 text-base">
        <li>التركيز على المهام الإبداعية والاستراتيجية</li>
        <li>تحسين جودة العمل</li>
        <li>تحقيق توازن أفضل بين العمل والحياة</li>
      </ul>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">الخلاصة</h2>
      <p class="text-base leading-relaxed mb-6">Formly AI ليس مجرد أداة لملء النماذج، بل هو استثمار في وقتك وإنتاجيتك. ابدأ اليوم واختبر الفرق بنفسك.</p>
    `
  },
  'custom-field-mapping': {
    id: 'custom-field-mapping',
    title: 'البدء مع تخصيص ربط الحقول',
    category: 'دروس تعليمية',
    author: 'سارة أحمد',
    authorImage: 'https://lh3.googleusercontent.com/aida-public/AB6AXuATRM3UNVWbVqaidOFF0uSpWP1NocSPl36s_6ZYswS66ATVGd0QZ0sJuQ073KtjYjtYMUfO-NgeCAZIw8mOFpcpK53o9uEyDhBUHi7veJ_JscsmQGracQ_vMmt0Owfz4IjtY7OB-VZMoaa8v7No_4uaX5dSomN2g8Kuh10NUvnPveURtV49HWFk2A7HFN4gqebT2nuz_f0YL1yholcDqDQDfrpFlBBi-jX5xuOxQosXKxFp1H7PV8jo7ZeYgRT91NRZWiyQgtzl064',
    date: '10 ديسمبر 2023',
    readTime: '5 دقائق قراءة',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAPdDiLf5sP6CaTAK9x4XoSgcYXnEEGBKg0g0zVx4UsDMR8gHfmVxYB_YQlIoXhcu7Umjjm6EQaNQHxdXE7LsM__gOHrN7XDU0tSnNJKzowHOYsmPWmK_ElRBDTBwjKuHbsf-avWVAUsN_lB1NCbNbmHqZ28Yq7lf4Vk8u2z6Mfsi77Txw6_08shEMhpgtbfESE6cZsMpZ4nsOp1UyUFuKfQfGp4LpfTzsSBHr7BI-RcaC4gsmbagzXR_qBKhMy0GuV-svYMmP0BKE',
    excerpt: 'تعلم كيفية تكوين Formly AI للتعرف حتى على النماذج الداخلية الأكثر غموضاً في الشركة باستخدام محرك الربط المتقدم الجديد.',
    content: `
      <p class="text-base leading-relaxed mb-6">تخصيص ربط الحقول هو أحد أقوى الميزات في Formly AI. يتيح لك هذا النظام ربط الحقول في النماذج المختلفة ببياناتك الشخصية بذكاء ودقة.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">ما هو ربط الحقول؟</h2>
      <p class="text-base leading-relaxed mb-6">ربط الحقول يسمح لـ Formly AI بفهم العلاقة بين الحقول المختلفة في النماذج. على سبيل المثال، عندما ترى حقل "الاسم الكامل"، تعرف الإضافة أنه يجب ملؤه باسمك الكامل من ملفك الشخصي.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">كيف تبدأ؟</h2>
      <p class="text-base leading-relaxed mb-6">ابدأ بفتح لوحة التحكم في Formly AI. من هناك، يمكنك الوصول إلى قسم "ربط الحقول" حيث ستجد واجهة سهلة الاستخدام لإدارة الربط.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">نصائح متقدمة</h2>
      <p class="text-base leading-relaxed mb-6">للاستفادة القصوى من هذه الميزة، تأكد من:</p>
      <ul class="list-disc list-inside space-y-2 mb-6 text-base">
        <li>استخدام أسماء واضحة للحقول في ملفك الشخصي</li>
        <li>اختبار الربط على نماذج مختلفة</li>
        <li>تحديث الربط بانتظام عند تغيير هيكل النماذج</li>
      </ul>
    `
  },
  'deep-work-mastery': {
    id: 'deep-work-mastery',
    title: 'إتقان فن العمل العميق',
    category: 'نصائح الإنتاجية',
    author: 'محمد علي',
    authorImage: 'https://lh3.googleusercontent.com/aida-public/AB6AXuATRM3UNVWbVqaidOFF0uSpWP1NocSPl36s_6ZYswS66ATVGd0QZ0sJuQ073KtjYjtYMUfO-NgeCAZIw8mOFpcpK53o9uEyDhBUHi7veJ_JscsmQGracQ_vMmt0Owfz4IjtY7OB-VZMoaa8v7No_4uaX5dSomN2g8Kuh10NUvnPveURtV49HWFk2A7HFN4gqebT2nuz_f0YL1yholcDqDQDfrpFlBBi-jX5xuOxQosXKxFp1H7PV8jo7ZeYgRT91NRZWiyQgtzl064',
    date: '8 ديسمبر 2023',
    readTime: '4 دقائق قراءة',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDo8Xic3yoVnszb7yyt9C1YYaDfbIU30aQVGKjsQ5_9XbeC0Qn_sp-43YRAjO0I5NrNO1m9xuHr6sZ2j62CF55o0dX0ncUsgwoRXX6NQ-TiYMtd08r5J4wuMEU9-MNFPmVIjF22Xq5pejpB99H-SkmpmUPioRN4_wx_TIDwkKaLsy_i2zOP8Ib36Dd69Km1BPleplpYoKc20JyHYGMoLcMJdIVCsVqdUscitHIlwrA-7Xrqts6bcI6YBFazVOWn9ORGx_uBYX2mmk',
    excerpt: 'كيف تسمح لك أتمتة إدخال البيانات بالبقاء في حالة التركيز لفترات أطول من الوقت دون انقطاع.',
    content: `
      <p class="text-base leading-relaxed mb-6">العمل العميق هو القدرة على التركيز دون انقطاع على مهمة معرفية صعبة. في عالم اليوم المشتت، أصبح الحفاظ على هذا التركيز تحدياً حقيقياً.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">التحدي</h2>
      <p class="text-base leading-relaxed mb-6">كل انقطاع، حتى لو كان بسيطاً مثل ملء نموذج، يكسر حالة التركيز العميق. يستغرق العقل البشري ما يصل إلى 23 دقيقة للعودة إلى نفس مستوى التركيز بعد الانقطاع.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">الحل: الأتمتة</h2>
      <p class="text-base leading-relaxed mb-6">من خلال أتمتة المهام المتكررة مثل ملء النماذج، يمكنك تقليل الانقطاعات بشكل كبير. Formly AI يتولى هذه المهام تلقائياً، مما يسمح لك بالبقاء في حالة التركيز.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">استراتيجيات العمل العميق</h2>
      <ul class="list-disc list-inside space-y-2 mb-6 text-base">
        <li>حدد أوقاتاً محددة للعمل العميق</li>
        <li>أزل جميع مصادر التشتت</li>
        <li>استخدم أدوات الأتمتة مثل Formly AI</li>
        <li>خذ فترات راحة منتظمة</li>
      </ul>
    `
  },
  'winter-release-crm': {
    id: 'winter-release-crm',
    title: 'الإصدار الشتوي: تكاملات CRM جديدة',
    category: 'تحديثات المنتج',
    author: 'فريق Formly',
    authorImage: 'https://lh3.googleusercontent.com/aida-public/AB6AXuATRM3UNVWbVqaidOFF0uSpWP1NocSPl36s_6ZYswS66ATVGd0QZ0sJuQ073KtjYjtYMUfO-NgeCAZIw8mOFpcpK53o9uEyDhBUHi7veJ_JscsmQGracQ_vMmt0Owfz4IjtY7OB-VZMoaa8v7No_4uaX5dSomN2g8Kuh10NUvnPveURtV49HWFk2A7HFN4gqebT2nuz_f0YL1yholcDqDQDfrpFlBBi-jX5xuOxQosXKxFp1H7PV8jo7ZeYgRT91NRZWiyQgtzl064',
    date: '5 ديسمبر 2023',
    readTime: '3 دقائق قراءة',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCSPxSePvbYWyc3xXayuJfv47XUTP9qAOvQpVRaPqZ0B-mIxREqHgwLtp_lqU15KcatpSAyo_3sHNcg4-GGYT_JiSqeYapFay7d38b9wD4DcFHZAIaBn4nNrWuYRwpkCUVIRK8rDkaQ4s5EA01K4znCoDiBrYJieyKeUlrICarMTAQ_IcIgGv9dzLDT5x1DUuHJ_TsT4RzisY9X9iV-PZVxbuQKTgw2Mmyey9pPKvx4tbrhVSdJr38eSLLrlfNP5X56db2t_edZxJ0',
    excerpt: 'أضفنا دعمًا أصليًا لـ Salesforce و HubSpot و Pipedrive. قم بمزامنة بيانات النماذج تلقائيًا مباشرة في خط أنابيب المبيعات الخاص بك.',
    content: `
      <p class="text-base leading-relaxed mb-6">نحن متحمسون للإعلان عن إصدارنا الشتوي الذي يجلب تكاملات قوية مع أنظمة CRM الرائدة في السوق.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">التكاملات الجديدة</h2>
      <p class="text-base leading-relaxed mb-6">الآن يمكنك ربط Formly AI مباشرة مع:</p>
      <ul class="list-disc list-inside space-y-2 mb-6 text-base">
        <li><strong>Salesforce:</strong> مزامنة تلقائية لبيانات النماذج</li>
        <li><strong>HubSpot:</strong> تحديث تلقائي لجهات الاتصال</li>
        <li><strong>Pipedrive:</strong> إنشاء صفقات تلقائياً</li>
      </ul>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">كيف تبدأ؟</h2>
      <p class="text-base leading-relaxed mb-6">اذهب إلى إعدادات Formly AI واختر "التكاملات". من هناك، يمكنك ربط حساب CRM الخاص بك في دقائق.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">المميزات</h2>
      <ul class="list-disc list-inside space-y-2 mb-6 text-base">
        <li>مزامنة فورية للبيانات</li>
        <li>تشفير آمن لجميع الاتصالات</li>
        <li>دعم متعدد الحسابات</li>
      </ul>
    `
  },
  'semantic-forms-future': {
    id: 'semantic-forms-future',
    title: 'مستقبل النماذج الدلالية على الويب',
    category: 'اتجاهات الذكاء الاصطناعي',
    author: 'د. ليلى محمود',
    authorImage: 'https://lh3.googleusercontent.com/aida-public/AB6AXuATRM3UNVWbVqaidOFF0uSpWP1NocSPl36s_6ZYswS66ATVGd0QZ0sJuQ073KtjYjtYMUfO-NgeCAZIw8mOFpcpK53o9uEyDhBUHi7veJ_JscsmQGracQ_vMmt0Owfz4IjtY7OB-VZMoaa8v7No_4uaX5dSomN2g8Kuh10NUvnPveURtV49HWFk2A7HFN4gqebT2nuz_f0YL1yholcDqDQDfrpFlBBi-jX5xuOxQosXKxFp1H7PV8jo7ZeYgRT91NRZWiyQgtzl064',
    date: '1 ديسمبر 2023',
    readTime: '12 دقيقة قراءة',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAJq2tgKM4UI-T4oZ-P70fEK950ppZYxWpfmvy7GxChJQS4gyp-uYy0peizbBmLARTIlxXHpRARGHgnfRvdS3zzrnDSBEbD16gURuRnzr_WkAr4--fKiKi5wd19gg0O6WOneu8nGZCF3aY48PPHixR5026oeYXJH9z1ccFHK0WUZgOTVjOQ7okGE9NxWAWX9PfRJ7jPfxrGIFhhjHy81Nz1v9yspWoTiNsTuRdEtKe9VCE0y7hXNy2htX7h6V6OVasyDrTbl0taKpA',
    excerpt: 'غوص عميق في كيفية حل نماذج اللغة الكبيرة أخيراً لمشكلة البيانات غير المهيكلة على الويب.',
    content: `
      <p class="text-base leading-relaxed mb-6">الويب مليء بالبيانات غير المهيكلة. النماذج، على الرغم من كونها واجهة شائعة، غالباً ما تكون غير منظمة وصعبة الفهم للآلات.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">التحدي التقني</h2>
      <p class="text-base leading-relaxed mb-6">لفترة طويلة، واجهت أنظمة الذكاء الاصطناعي صعوبة في فهم النماذج بسبب عدم وجود معايير موحدة. كل موقع يستخدم هيكلاً مختلفاً، مما يجعل الأتمتة صعبة.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">الحل: النماذج الدلالية</h2>
      <p class="text-base leading-relaxed mb-6">نماذج اللغة الكبيرة (LLMs) مثل تلك المستخدمة في Formly AI تغير هذا الواقع. هذه النماذج يمكنها فهم السياق والدلالة، مما يسمح لها بفهم النماذج حتى لو كانت غير منظمة.</p>
      
      <h2 class="text-2xl font-bold mb-4 mt-8">المستقبل</h2>
      <p class="text-base leading-relaxed mb-6">مع تطور تقنيات الذكاء الاصطناعي، نتوقع أن تصبح النماذج أكثر ذكاءً وقدرة على التكيف. المستقبل يعد بثورة في كيفية تفاعلنا مع النماذج على الويب.</p>
    `
  }
};

function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const post = blogPosts[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return (
      <div className="bg-background-light dark:bg-background-dark text-[#111318] dark:text-white">
        <Header />
        <main className="max-w-[800px] mx-auto px-4 py-16 text-center">
          <h1 className="text-3xl font-bold mb-4">المقال غير موجود</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-8">عذراً، المقال الذي تبحث عنه غير موجود.</p>
          <Link to="/blog" className="text-primary font-bold hover:underline">
            العودة إلى المدونة
          </Link>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-background-light dark:bg-background-dark text-[#111318] dark:text-white transition-colors duration-300">
      <Header />
      <main className="max-w-[800px] mx-auto px-4 pt-4 pb-8 md:pt-8 relative">
        {/* Back Button - Absolute Right */}
        <button
          onClick={() => navigate(-1)}
          className="static md:absolute md:top-8 md:right-[-120px] flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-bold text-sm whitespace-nowrap z-10 mb-4 md:mb-0"
        >
          <span className="material-symbols-outlined">arrow_back</span>
          <span>العودة</span>
        </button>
        
        {/* Article Header */}
        <article>
          <div className="mb-6 pr-0 md:pr-32">
            <h1 className="text-lg md:text-4xl font-bold leading-tight mb-4 overflow-hidden line-clamp-2 md:line-clamp-none md:overflow-visible">
              {post.title}
            </h1>
            <div>
              <span className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs font-bold rounded-full uppercase tracking-wider">
                {post.category}
              </span>
            </div>
          </div>

          {/* Featured Image */}
          {post.image && (
            <div 
              className="w-full aspect-video rounded-xl mb-8 bg-cover bg-center"
              style={{backgroundImage: `url('${post.image}')`}}
            ></div>
          )}

          {/* Article Content */}
          <div className="prose prose-lg max-w-none dark:prose-invert">
            <div className="text-base leading-relaxed space-y-6" dangerouslySetInnerHTML={{ __html: post.content }}></div>
          </div>

          {/* Share Section */}
          <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
            <p className="text-sm font-bold mb-4">شارك المقال:</p>
            <div className="flex gap-4">
              <button className="size-10 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center hover:bg-primary hover:text-white transition-colors">
                <span className="material-symbols-outlined text-lg">share</span>
              </button>
              <button className="size-10 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center hover:bg-primary hover:text-white transition-colors">
                <span className="material-symbols-outlined text-lg">link</span>
              </button>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default BlogPost;

